'use strict';

function checkUpcomingTreatments(selectedHorseIDs, activityDate){

    var checkURL = '/components/daily.cfc?' + jQuery.param({
        method: 'getUpcomingTreatmentsCountWeb',
        horseID: selectedHorseIDs,
        activityDate: activityDate,
    });

    $.ajax(
        {
            type: 'POST',
            url: checkURL,
            data: {
                value: 'True',
                ran: gen_random(),
            },
            dataType: 'json',
            cache: false,
            success: function(data)
            {

                if (data > 0){
                    return data.treatmentCount;

                } else {
                    return 0;
                }

            },
            error: function(data, textStatus , jqXHR)
            {
                // eslint-disable-next-line max-len
                console.log('Unable to connect to server at this time. Please try your internet connection and try again');
                $('#existing_reminders_container').customHide();
            },
        });

}

export function moveSelectedHorses(options) {

    if (!options){
        options = {};
    }

    var popupTitle = 'Confirm Movement';

    if (!options.isPopWin) {
        options.isPopWin = false;
    }

    if (!options.oneHorseOnly) {
        options.oneHorseOnly = false;
    }

    if (!options.horseID) {
        options.horseID = '';
    }

    if (!options.movementSelections) {
        options.movementSelections = '';
    }

    if (!options.mainFormID) {
        options.mainFormID = '';
    }

    if (!options.isBillingCentre) {
        options.isBillingCentre = false;
    }

    if (!options.defaultStatus) {
        options.defaultStatus = 0;
    }

    if (options.isPopWin && options.oneHorseOnly){
        var selectedHorseIDs = options.horseID;
    } else {
        var selectedHorseIDs = options.movementSelections;
    }

    if (selectedHorseIDs.length < 1){
        EQLAPP.STRIPE.showAlert({title: 'Alert',
            body: 'Please select at least one horse to move',
        });
        return;
    } else {
        var formValid = $('#' + options.mainFormID).valid();
        var formID = $('#' + options.mainFormID);
        if (formValid) {
            var farmID = formID.find("[name='farm_id']").val();
            var yardID = formID.find("[name='yard_id']").val();
            var boxID = formID.find("[name='box_id']").val();
            var movementDate = formID.find("[name='movementDate']").val();
            var movementTime = formID.find("[name='movementTime']").val();
            var farmName = formID.find("[name='farm_name']").val();
            var yardName = formID.find("[name='yard_name']").val();
            var boxName = formID.find("[name='box_name']").val();
            var showDate = formID.find("[name='showTime']").is(':checked');
            var charge = formID.find("[name='charge']").val();

            if (!options.oneHorseOnly){
                //Show Confirmation Popup
                var popURL = '/pages/pop/horse/movementConfirm.cfm?' + jQuery.param({
                    horseIDs: selectedHorseIDs.toString(),
                    farmID: farmID,
                    farmName: farmName,
                    yardID: yardID,
                    yardName: yardName,
                    boxID: boxID,
                    boxName: boxName,
                    movementDate: movementDate,
                    movementTime: movementTime,
                    showDate: showDate,
                    charge: charge,
                    c_popwin: options.isPopWin,
                });

                popWin({
                    title: popupTitle,
                    popID: 'horseMovementConfirm',
                    noAutoWidth: true,
                    page: popURL,
                    width: 744,
                    modal: true,
                });
            } else {
                //Direct Save for single horse
                var upcomingTreatments = checkUpcomingTreatments(selectedHorseIDs,movementDate);

                saveMovement({
                    selectedHorseIDs: selectedHorseIDs,
                    isBillingCentre: options.isBillingCentre,
                    upcomingTreatments: upcomingTreatments,
                    movementDate: movementDate,
                    mainFormID: options.mainFormID,
                    defaultStatus: options.defaultStatus,
                });

            }
        }
    }
}

export function saveMovement(options){
    if (!options){
        options = {};
    }

    if (!options.selectedHorseIDs) {
        options.selectedHorseIDs = '';
    }

    if (!options.isBillingCentre) {
        options.isBillingCentre = false;
    }

    if (!options.upcomingTreatments) {
        options.upcomingTreatments = 0;
    }

    if (!options.movementDate) {
        options.movementDate = '';
    }

    if (!options.mainFormID) {
        options.mainFormID = '';
    }

    if (!options.defaultStatus) {
        options.defaultStatus = 0;
    }

    var formValid = $('#' + options.mainFormID).valid();
    var formID = $('#' + options.mainFormID);
    if (formValid) {

        formID.find("[name='horseIDs']").val(options.selectedHorseIDs);

        if (!options.isBillingCentre && options.upcomingTreatments > 0){
            deleteUpcomingTreatments(
                options.selectedHorseIDs,
                options.movementDate,() =>{
                    popWinClose('horseMovementConfirm');
                    postUsingAjax({
                        formID: options.mainFormID,
                        onSuccess: function(){
                            $('#locationPopUp').jqmHide();
                            refreshCalendar();
                            agwToggleMovementButton(true);
                        },
                    });
                });
        } else {
            popWinClose('horseMovementConfirm');
            postUsingAjax({
                formID: options.mainFormID,
                onSuccess: function(){
                    $('#locationPopUp').jqmHide();
                    refreshCalendar();
                    agwToggleMovementButton(true);
                },
            });
        }
    }
}

export function changeMovementDate(options) {

    if (!options){
        options = {};
    }

    if (!options.horseID) {
        options.horseID = '';
    }

    if (!options.movementDate) {
        options.movementDate = '';
    }

    if (!options.onSuccess) {
        options.onSuccess = '';
    }

    var checkURL = '/components/daily.cfc?' + jQuery.param({
        method: 'checkMatchingActivityDetails',
        horseIDs: options.horseID.toString(),
        activityID: 2,
        actvityDate: options.movementDate,
        countOnly: 'true',
    });

    $.ajax(
        {
            type: 'POST',
            url: checkURL,
            data: {
                value: 'True',
                ran: gen_random(),
            },
            dataType: 'json',
            cache: false,
            success: options.onSuccess,
            error: function(data, textStatus , jqXHR)
            {
                // eslint-disable-next-line max-len
                console.log('Unable to connect to server at this time. Please try your internet connection and try again');
                $('#existing_reminders_container').customHide();
            },
        });
}

export function refreshMovementGrid(options)
{
    if (!options){
        options = {};
    }

    if (!options.gridBaseURL) {
        options.gridBaseURL = '';
    }

    if (!options.horseID) {
        options.horseID = '';
    }

    if (!options.$jqMovementGridObj) {
        options.$jqMovementGridObj = '';
    }

    if (!options.dateFormat) {
        options.dateFormat = '';
    }

    if (!options.fullAccess) {
        options.fullAccess = false;
    }

    if (!options.rowNum) {
        options.rowNum = 0;
    }

    if (!options.pagerID) {
        options.pagerID = '';
    }

    if (!options.movementID) {
        options.movementID = '';
    }

    if (!options.isPopWin) {
        options.isPopWin = false;
    }

    var searchURL = jQuery.param.querystring(options.gridBaseURL,{
        horseID: options.horseID,
    });

    let gridWidth = '';
    if (!options.isPopWin){
        EQLAPP.COMMON.register({
            'gridID': 'jq_daily_movement_details',
        });
    } else {
        gridWidth = 800;
    }

    if (!options.$jqMovementGridObj[0].grid) {
        // Create horse movement grid (not horse selection)
        options.$jqMovementGridObj.jqGrid({
            url: searchURL,
            datatype: 'JSON',
            colNames: ['ID',
                'Horse ID',
                'Horse',
                'Code',
                'Date',
                'Time',
                'Description',
                'Farm',
                'Yard',
                'Box',
                'Note',
                'Colour',
                'Billing Centre',
                'Edit',
                'Delete',
            ], //Column Names
            colModel: [
                {
                    name: 'dailyID',
                    index: 'dailyID',
                    width: 75,
                    sorttype: 'int',
                    hidden: true
                    ,editable: false,
                    searchoptions: {
                        sopt: ['bw'],
                    },
                },
                {
                    name: 'horseID',
                    index: 'horseID',
                    width: 75,
                    sorttype: 'int',
                    hidden: true,
                    editable: false,
                    searchoptions: {sopt: ['bw']},
                },
                {
                    name: 'horseName',
                    index: 'horseName',
                    width: 135,
                    hidden: true,
                    sorttype: 'text',
                    search: true,
                    stype: 'text',
                    classes: 'pointer',
                },
                {
                    name: 'activityCodeDescription',
                    index: 'activityCodeDescription',
                    hidden: true,
                    width: 80,
                    sorttype: 'text',
                    search: true,
                    stype: 'text',
                    classes: 'pointer',
                },
                {
                    name: 'dailyDate',
                    index: 'dailyDate',
                    width: 81,
                    hidden: true,
                    formatter: 'date',
                    formatoptions: {
                        srcformat: 'Y-m-d',
                        newformat: options.dateFormat,
                    },
                    sorttype: 'Date',
                    hidden: false,
                    search: true,
                    classes: 'pointer'},
                {
                    name: 'dailyTime',
                    index: 'dailyTime',
                    width: 76,
                    hidden: true,
                    formatter: 'date',
                    formatoptions: {
                        srcformat: 'ISO8601Long',
                        newformat: 'h:i A',
                    },
                    sorttype: 'Date',
                    hidden: false,
                    search: true,
                    classes: 'pointer'},
                {
                    name: 'dailyInputDescription',
                    index: 'dailyInputDescription',
                    width: 150,
                    hidden: true,
                    sorttype: 'text',
                    search: true,
                    stype: 'text',
                    classes: 'pointer',
                },
                {
                    name: 'farmname',
                    index: 'farmname',
                    width: 135,
                    sorttype: 'text',
                    search: false,
                    stype: 'text',
                    classes: 'pointer',
                },
                {
                    name: 'yardName',
                    index: 'yardName',
                    width: 102,
                    sorttype: 'text',
                    search: false,
                    stype: 'text',
                    classes: 'pointer',
                },
                {
                    name: 'boxName',
                    index: 'boxName',
                    width: 76,
                    sorttype: 'text',
                    search: false,
                    stype: 'text',
                    classes: 'pointer',
                },
                {
                    name: 'note',
                    index: 'note',
                    width: 98,
                    sorttype: 'text',
                    search: false,
                    stype: 'text',
                    classes: 'pointer',
                },
                {
                    name: 'colour',
                    index: 'colour',
                    hidden: true,
                    width: 150,
                    sorttype: 'text',
                    search: true,
                    stype: 'text',
                },
                {
                    name: 'billingCentre',
                    index: 'billingCentre',
                    hidden: true,
                    width: 150,
                    sorttype: 'text',
                    search: true,
                    stype: 'text',
                },
                {
                    name: 'edit',
                    width: 36,
                    align: 'center',
                    sortable: false,
                    classes: 'option edit',
                    hidden: !options.fullAccess,
                },
                {
                    name: 'delete',
                    width: 36,
                    align: 'center',
                    sortable: false,
                    classes: 'option remove',
                    hidden: !options.fullAccess,
                },
            ],

            rowNum: options.rowNum,
            pager: options.pagerID,
            height: '100%',
            autowidth: true,
            width: gridWidth,
            sortorder: 'DESC',
            sortname: 'dailyDate',
            onCellSelect: function(rowid,iCol,cellcontent,e)
            {
                dailyMovementSubClick(rowid,iCol,cellcontent,e,'jq_daily_movement');
            },
            loadComplete: function(){
                options.$jqMovementGridObj.setGridWidth(725);
                if (typeof options.movementID === 'number'){
                    $(this).jqGrid('setSelection',options.movementID);
                    var gridUrl = $(this).getGridParam('url');
                    gridUrl = gridUrl.replace(/&jqGridId=\d*/,'');
                    $(this).setGridParam({url: gridUrl});
                }

                var rowIDS = options.$jqMovementGridObj.getDataIDs();

                var colorListExists = $('#colorList').length;

                if (colorListExists > 0){
                    $('#colorList').empty();
                } else {
                    $('#' + options.pagerID)
                        .parent()
                        .after('<div id=colorList class="margin_top colorHorizontal"></div>');
                }

                $.each(rowIDS,(intIndex, rowID) =>
                {
                    $('#' + rowID).addClass('pointer');

                    //Highlight Locations
                    var locationColour = options.$jqMovementGridObj.jqGrid('getCell',
                        rowID,
                        'colour');
                    var billingCentre = options.$jqMovementGridObj.jqGrid('getCell',
                        rowID,
                        'billingCentre');
                    if (locationColour.length > 0)
                    {
                        //Style Row Differently
                        $('#' + rowID).css('color',locationColour);

                        var colorItemExists = $('#\\' + locationColour).length;

                        if (colorItemExists == 0){
                            // eslint-disable-next-line max-len
                            $('#colorList').append("<div class='margin_right' id=" + locationColour + ">  <div style='background:" + locationColour + "' class='colourBox'></div> " + billingCentre + ' </div>');
                        }

                    }

                });

                window.dispatchEvent(new Event('resize'));

            },

        });

    }
    else
    {
        // Update URL to include horse id filter
        // and load data into the Horse Movement Grid (not horse select)
        options.$jqMovementGridObj.jqGrid('setGridParam',
            {url: searchURL,
                page: 1}).trigger('reloadGrid');
    }

}

export function init(options) {
    if (!options) {
        options = {};
    }
    $('.jq_button').button();
}
